import { useState, useMemo } from "react";
import Slider from '@mui/material/Slider';
import { DateTimePicker } from '@mui/x-date-pickers';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import moment, { Moment } from 'moment-timezone';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useStoreContext } from "src/store/context";
import { useCurrentDateSlider, useDates, useMidDateSelected } from "src/store/actions";
import { ONEDAY, ONEMIN, ONESEC, ONEHR } from "src/store/common";
import { HrCustomLayout } from "src/features/field-sample/Samples/Sample";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

/*To Do : Maybe store the other calls somewhere so we don't have to make same call if user is going back to the latest obesrvation*/
export default function WeatherDateSlider() {
  
  const [state, dispatch] = useStoreContext();
  const setDates = useDates(dispatch);
  const setMiddleDate = useMidDateSelected(dispatch);
  const setCurrentSliderDate = useCurrentDateSlider(dispatch);
  const [notInRange, setNotInRange] = useState(false);
  const [hrString, setHrString] = useState('');
  const [dateString, setDateString] = useState('');
  const [checkDateValid, setCheckDateValid] = useState<boolean>(true);

  /*useMemo below is to update the date to present the user on the date time slider*/
  useMemo(() => {
    setDateString(moment.tz(state.currentSliderDate, state.userTimeZone.id[0]).format('MMMM') + " " + moment.tz(state.currentSliderDate, state.userTimeZone.id[0]).format('DD') + "," + moment.tz(state.currentSliderDate, state.userTimeZone.id[0]).format('YYYY'))
    setHrString(`  ${moment.tz(state.currentSliderDate, state.userTimeZone.id[0]).format('HH')}:00  ${state.userTimeZone.code}`)
  }, [state.userTimeZone, state.currentSliderDate]);

  const handleDecrease = (amount: number) => {
    const newTime = state.currentSliderDate - amount;
    setCurrentSliderDate(newTime);
    setDates([new Date(newTime - (30 * ONEMIN)), new Date(newTime + (30 * ONEMIN) - ONESEC)]);
    if(newTime <=state.midDate-7*ONEDAY){
      setMiddleDate(newTime-7*ONEDAY)
    }

  }
  const handleIncrease = (amount: number) => {
    const newTime = state.currentSliderDate + amount;
    setCurrentSliderDate(newTime);
    setDates([new Date(newTime - (30 * ONEMIN)), new Date(newTime + (30 * ONEMIN) - ONESEC)])
    if(newTime >=state.midDate+7*ONEDAY && newTime<state.currentDate+7*ONEDAY){
      setMiddleDate(newTime+7*ONEDAY)
    }
  }

  const handleYearDecrease = () => {
    const newTime = moment(state.currentSliderDate).subtract(1, 'years').valueOf();
    setCurrentSliderDate(newTime);
    setDates([new Date(newTime - (30 * ONEMIN)), new Date(newTime + (30 * ONEMIN) - ONESEC)]);
    if(newTime <=state.midDate-7*ONEDAY){
      setMiddleDate(newTime)
    }
  }

  const handleYearIncrease = () => {
    const newTime = moment(state.currentSliderDate).add(1, 'years').valueOf();
    setCurrentSliderDate(newTime);
    setDates([new Date(newTime - (30 * ONEMIN)), new Date(newTime + (30 * ONEMIN) - ONESEC)]);
    if(newTime >=state.midDate+7*ONEDAY && newTime<state.currentDate+7*ONEDAY){
      setMiddleDate(newTime)
    }
  }

  const currentHourButton = () =>{
    if(moment() >= moment(state.currentDate + (30*ONEMIN))){
      setNotInRange(false);
      setDates([new Date(state.currentDate+ (30*ONEMIN)), new Date(state.currentDate+ (ONEHR+(30*ONEMIN))-ONESEC)])
      setCurrentSliderDate(state.currentDate+ONEHR);
      setMiddleDate(state.currentDate+ONEHR);
    }
    else{
      setNotInRange(false);
      setDates([new Date(state.currentDate- (30*ONEMIN)), new Date(state.currentDate+ (30*ONEMIN)-ONESEC)])
      setCurrentSliderDate(state.currentDate);
      setMiddleDate(state.currentDate);
    }
  }

  const onChangeSlider = (e: any) => {
    setCurrentSliderDate(e.target.value);
    setDates([new Date(e.target.value - (30 * ONEMIN)), new Date(e.target.value + (30 * ONEMIN) - ONESEC)])
  }

  const handleDateTimePicker = (newValue: Moment | null) => {
    if(newValue?.isValid()){
      const newDate =  moment.tz(newValue,state.userTimeZone.id[0]);
      const newVal =  moment.tz(newValue,state.userTimeZone.id[0]).valueOf();
      if(newDate?.year()?.toString().length===4){
        setCheckDateValid(true)
        if((newVal > state.currentDate+ (7*ONEDAY) || newVal < state.currentDate- (14*ONEDAY)) && !localStorage.getItem('user')){
          setNotInRange(true);
        }
        else{
          setCurrentSliderDate(newVal);
          setNotInRange(false);
          setMiddleDate(newDate);
          setDates([new Date(newVal- (30*ONEMIN)), new Date(newVal+ (30*ONEMIN)-ONESEC)]);
        }
      }
      else{
        setCheckDateValid(false)

      }
    }
    else{
      setCheckDateValid(false)
    }
  };
  
  const checkPast7Days =(type: string)=>{
    if( type==='HR'){
      if(state.selectedRadio.type?.includes('daily')){
        return true
      }
      else if(moment.utc(state.currentSliderDate).set({ hour: 24, minute: 59 }).isAfter(moment.utc(state.currentDate).set({ hour: 24, minute: 59 }).add(6, 'days'))){
        return true
      }
      else{
        return false
      }
    
    }
    else if( type==='DAY' && moment(state.currentSliderDate).add(1, 'hour').isAfter(moment(state.currentDate).add(6, 'days'))){
      return true
    }
    else if( type==='YR' && moment(state.currentSliderDate).add(1, 'years').valueOf() >= state.currentDate+6*ONEDAY){
      return true
    }
    else{
      return false
    }
  }

  const checkPast14PreviousDays = (type:string) =>{
    if(!localStorage.getItem('user')){
      if(state.currentSliderDate<= state.currentDate -14*ONEDAY){
        return true
      }
      else if( type==='HR' && (state.currentSliderDate+ONEHR <= state.currentDate-14*ONEDAY || state.selectedRadio.type==='daily')){
        return true
      }
      else if( type==='DAY' && state.currentSliderDate+ONEDAY <= state.currentDate-14*ONEDAY){
        return true
      }
      else if( type==='YR' && moment(state.currentSliderDate).subtract(1, 'years').valueOf() <= state.currentDate+14*ONEDAY){
        return true
      }
      else{
        return false
      }
    }
    else{
      if( type==='HR' && state.selectedRadio.type==='daily'){
        return true
      }
      else{
        return false
      }
    }
  }
  return (
    <div className="dateTimePicker">
      <Stack
        alignItems="center">
        <div className="dateCalendarPicker">'
          <LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>
            {
              state.selectedRadio.type ==='hourly'&&
              (
                !localStorage.getItem('user') ?
                (
                  <DateTimePicker
                    format="MM/DD/YYYY HH:00"
                    value={moment.tz(state.midDate, state.userTimeZone.id[0])}
                    minDate={moment.tz(state.currentDate - 14 * ONEDAY, state.userTimeZone.id[0])}
                    maxDate={moment.tz(state.currentDate, state.userTimeZone.id[0]).add(6, 'days')}
                    ampm={false}
                    timezone={state.userTimeZone.id[0]}
                    onChange={(newValue) => { handleDateTimePicker(newValue) }}
                    views={['year', 'month', 'day', 'hours']}
                    slots={{ layout: HrCustomLayout }}
                    slotProps={{
                      textField: {
                        id: "TimePicker",
                        error: notInRange || !checkDateValid ? true : false,
                        helperText: notInRange || !checkDateValid ? 'Enter a Valid Date' : ''
                      },
                    }}
                  />
                ) :
                (
                  <DateTimePicker
                    format="MM/DD/YYYY HH:00"                    
                    value={moment.tz(state.midDate, state.userTimeZone.id[0])}
                    maxDate={moment.tz(state.currentDate, state.userTimeZone.id[0]).add(6, 'days')}
                    ampm={false}
                    timezone={state.userTimeZone.id[0]}
                    onChange={(newValue) => { handleDateTimePicker(newValue) }}
                    views={['year', 'month', 'day', 'hours']}
                    slots={{ layout: HrCustomLayout }}
                    slotProps={{
                      textField: {
                        id: "TimePicker",

                        error: !checkDateValid ? true : false,
                        helperText: !checkDateValid ? 'Enter a Valid Date' : '',
                      },
                    }}
                  />
                )
              )
            }
            {
              state.selectedRadio.type==='daily' &&
              (
                !localStorage.getItem('user') ?
                (
                  <DatePicker
                  value={moment.tz(state.midDate, state.userTimeZone.id[0])}
                  slotProps={{
                    textField: {
                      id: "TimePicker",
                      error: notInRange || !checkDateValid ? true : false,
                      helperText: notInRange || !checkDateValid ? 'Enter a Valid Date' : '',
                    },
                  }}
                  timezone={state.userTimeZone.id[0]}
                  onChange={(newValue) => { handleDateTimePicker(newValue) }}
                  minDate={moment.tz(state.currentDate, state.userTimeZone.id[0]).subtract(14, 'days')}
                  maxDate={moment.tz(state.currentDate, state.userTimeZone.id[0]).add(6, 'days')}
                />
                ):(
                  <DatePicker
                  value={moment.tz(state.midDate, state.userTimeZone.id[0])}
                  slotProps={{
                    textField: {
                      id: "TimePicker",
                      error: notInRange || !checkDateValid ? true : false,
                      helperText: notInRange || !checkDateValid ? 'Enter a Valid Date' : '',
                    },
                  }}
                  timezone={state.userTimeZone.id[0]}
                  onChange={(newValue) => { handleDateTimePicker(newValue) }}
                  maxDate={moment.tz(state.currentDate, state.userTimeZone.id[0]).add(6, 'days')}
                />
                )
              )

            }
          </LocalizationProvider>
          <Button style={{ width: '100%', textTransform: 'capitalize', fontSize: '11px'}}
            variant="contained" onClick={currentHourButton}
          >
            <div>Current</div>
            <i className="fas fa-sync" style={{ paddingLeft: '5px' }} />
          </Button>
        </div>

        {!localStorage.getItem('user') &&
          <div style={{ fontSize: '11px', fontStyle: "italic", textAlign: 'center' }}>Need more than 3 weeks of data? Please sign in</div>
        }

        <div>{(
          <div>
            <span style={{ fontWeight: 'bold' }}>
              {dateString}
            </span>
            {
              state.selectedRadio.type ==='hourly' &&
              <span>
                {hrString}
              </span>
            }

          </div>
        )}</div>
      </Stack>
      {
        !localStorage.getItem('user') ? (
          <Slider
            value={state.currentSliderDate}
            step={ONEDAY}
            marks
            max={moment(state.midDate).format('YYYY-MM-DD')===moment(state.currentDate).add(6, 'days').format('YYYY-MM-DD')? state.midDate: state.midDate + 6 * ONEDAY}
            aria-label="TimeSlider"
            min={((state.midDate - (state.currentDate - 14 * ONEDAY)) / (1000 * 3600 * 24)) <= 7 ? state.midDate - (((state.midDate - (state.currentDate - 14 * ONEDAY)) / (1000 * 3600 * 24)) * ONEDAY) : state.midDate - 7 * ONEDAY}
            valueLabelDisplay="off"
            onChange={(e) => onChangeSlider(e)}
            track={false}
            size="medium"
          />
        ) : (
          <Slider
            value={state.currentSliderDate}
            step={ONEDAY}
            marks
            aria-label="TimeSlider"
            max={state.midDate + 6 * ONEDAY}
            min={state.midDate - 7 * ONEDAY}
            valueLabelDisplay="off"
            onChange={(e) => onChangeSlider(e)}
            track={false}
            size="medium"
          />)
      }
      <Stack direction="row" spacing={.5}>
        <Button style={{ textTransform: 'capitalize', fontSize: '12px', width: '1.2rem', }} color="secondary"
          variant="contained" onClick={handleYearDecrease}
          aria-disabled={checkPast14PreviousDays('YR')}
        >
          <i className="fas fa-caret-left" style={{ paddingRight: '5px' }} />
          <div>Yr</div>
        </Button>
        <Button style={{ textTransform: 'capitalize', fontSize: '12px', width: '3rem' }}
          variant="contained" onClick={()=>handleDecrease(ONEDAY)}
          aria-disabled={checkPast14PreviousDays('DAY')}
        >
          <i className="fas fa-caret-left" style={{ paddingRight: '5px' }} />
          <div>Day</div>
        </Button>
        <Button style={{ textTransform: 'capitalize', fontSize: '12px', width: '1.2rem', backgroundColor: 'white' }}
          variant="outlined" onClick={()=> handleDecrease(ONEHR)}
          aria-disabled={checkPast14PreviousDays('HR')}

        >
          <i className="fas fa-caret-left" style={{ paddingRight: '5px' }} />
          <div>Hr</div>
        </Button>
        <Button style={{ textTransform: 'capitalize', fontSize: '12px', width: '1.2rem', backgroundColor: 'white' }}
          variant="outlined" onClick={()=>handleIncrease(ONEHR)}
          aria-disabled={checkPast7Days('HR')}
        >
          <div style={{ paddingRight: '5px' }}>Hr</div>
          <i className="fas fa-caret-right" />
        </Button>
        <Button style={{ textTransform: 'capitalize', fontSize: '12px', width: '3rem' }}
          variant="contained" onClick={()=>handleIncrease(ONEDAY)}
          aria-disabled={checkPast7Days('DAY')}
        >
          <div style={{ paddingRight: '5px' }}>Day</div>
          <i className="fas fa-caret-right" />
        </Button>

        <Button style={{ textTransform: 'capitalize', fontSize: '12px', width: '1.2rem' }} color="secondary"
          variant="contained" onClick={handleYearIncrease}
          aria-disabled={checkPast7Days('YR')}
        >
          <div style={{ paddingRight: '5px' }}>Yr</div>
          <i className="fas fa-caret-right" />
        </Button>
      </Stack>
    </div>
    
  );
}